import { Component, EventEmitter, Output, Input } from '@angular/core';
import { ReservationsService } from '@app/shared/services/reservations.service';
declare var UIkit: any;
import * as moment from 'moment';
import { DateService } from '@app/shared/services/date.service';
import { AlertService } from '@app/shared/services/alert.service';

@Component({
  selector: 'app-change-reservation-period',
  templateUrl: './change-reservation-period.component.html',
  styleUrls: ['./change-reservation-period.component.scss']
})
export class ChangeReservationPeriodComponent {

  /* Datepicker */

  public dateStart: string = '';
  public dateEnd: string = '';
  public hourStart: number = 0;
  public minuteStart: number = 0;
  public hourEnd: number = 0;
  public minuteEnd: number = 0;

  /* State */

  public loading: boolean = false;
  @Input() id: number = 0;
  @Input() reservation: any = {};
  @Output() changed = new EventEmitter();

  constructor(
    private reservationService: ReservationsService,
    private dateService: DateService,
    private alertService: AlertService
  ) { }

  ngOnChanges() {
    let dates: any = {};

    if (Object.keys(this.reservation).length === 0)
      return;
    this.dateStart = moment(this.reservation.ISODateStart).format('DD/MM/YYYY').split('T')[0];
    this.dateEnd = moment(this.reservation.ISODateEnd).format('DD/MM/YYYY').split('T')[0];
    this.hourStart = this.reservation.ISODateStart.split('T')[1].split('.')[0].split(':')[0];
    this.minuteStart = this.reservation.ISODateStart.split('T')[1].split('.')[0].split(':')[1];
    this.hourEnd = this.reservation.ISODateEnd.split('T')[1].split('.')[0].split(':')[0];
    this.minuteEnd = this.reservation.ISODateEnd.split('T')[1].split('.')[0].split(':')[1];
  }

  updatePeriod() {
    let dates: any = {};

    dates.start = moment(this.dateStart, 'DD/MM/YYYY').format().split('T')[0] + 'T' + (this.hourStart.toString().length == 1 ? ("0" + this.hourStart) : (this.hourStart)) + ':' + (this.minuteStart.toString().length == 1 ? ("0" + this.minuteStart) : (this.minuteStart)) + ':00.000Z';
    dates.end = moment(this.dateEnd, 'DD/MM/YYYY').format().split('T')[0] + 'T' + (this.hourEnd.toString().length == 1 ? ("0" + this.hourEnd) : (this.hourEnd)) + ':' + (this.minuteEnd.toString().length == 1 ? ("0" + this.minuteEnd) : (this.minuteEnd)) + ':00.000Z';

    if (new Date(moment(this.dateStart, 'DD/MM/YYYY').format().split('T')[0] + "T" + (this.hourStart.toString().length == 1 ? ("0" + this.hourStart) : (this.hourStart)) + ':' + (this.minuteStart.toString().length == 1 ? ("0" + this.minuteStart) : (this.minuteStart)) + ':00').getTime() > new Date(moment(this.dateEnd, 'DD/MM/YYYY').format().split('T')[0] + "T" + (this.hourEnd.toString().length == 1 ? ("0" + this.hourEnd) : (this.hourEnd)) + ':' + (this.minuteEnd.toString().length == 1 ? ("0" + this.minuteEnd) : (this.minuteEnd)) + ':00').getTime()) {
      return this.alertService.error('La date de début doit être antérieure à la date de fin.');
    }

    dates = this.dateService.convertToLocal(dates);
    dates = this.dateService.convertToISO(dates);
    this.loading = true;
    this.reservationService.changeReservationPeriod(this.id, dates.start, dates.end).then((res) => {
      this.loading = false;
      this.changed.emit();
      UIkit.modal('#change-reservation-period').hide();
    });
  }

}
